import { render } from "./modal-event.vue?vue&type=template&id=c3c6e7bc"
import script from "./modal-event.vue?vue&type=script&lang=js"
export * from "./modal-event.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/ALL_REPO/Web-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__